export const visibilityWordBlacklist = ['Tb ', 'Bin ']

export function sentenceTitleCase(text, except = []){
  let result
  var replaced = text.replace( /([A-Z])/g, " $1" );
  var uppercased = replaced.charAt(0).toUpperCase() + replaced.slice(1);

  if(except && except.length > 0){
    let filtered = uppercased
    for (let index = 0; index < except.length; index++) {
      const word = except[index];
      if(uppercased.includes(word)){
        const temp = filtered.split(word).join('')
        filtered = temp
      }
    }
    result = filtered
  } else {
    result = uppercased
  }

  return result
}
